
import { NOTIFICATION_DETAILING_MODAL_KEY } from '../constants';
import Vue from 'vue';
import { restApi } from '@/components/mixins/restApi';
import mixins from 'vue-typed-mixins';
import { workflowHelpers } from '@/components/mixins/workflowHelpers';
import InfoAliare from '@/components/InfoAliare.vue';

import Modal from './Modal.vue';
import ModalButtonSuccess from '@/components/ModalButtonSuccess.vue'
import WebStorage from '@/common/WebStorage';


import { executionLogPermission } from '@/components/mixins/permissions/executionLog';

import ModalButtonCancel from '@/components/ModalButtonCancel.vue';
import { copyPaste } from '@/components/mixins/copyPaste';
import InteractionMenu from '@/components/InteractionMenu.vue';

export default mixins(
	restApi,
	workflowHelpers,
	executionLogPermission,
    copyPaste,
).extend({
	name: 'NotificationDetailingModal',
	components: {
		Modal,
		ModalButtonCancel,
        InfoAliare,
		ModalButtonSuccess,
		InteractionMenu,
	},
    props: {
		dataModal: {
			type: Object,
		},
	},
	data() {
		return {
			modalBus: new Vue(),
			NOTIFICATION_DETAILING_MODAL_KEY,
			isLoadingPage: true,

            resultData: {
                id: '',
                nome: "",
                canal: "",
                resultados: [],
                workflows: [],
            },
            extendedMessageText: false,
            copiedMessageText: false,			
		};
	},
	computed: {

	},
	async mounted () {
        this.initModal();
	},
	async created() {
		
	},
	methods: {
        openEditNotification(id) {
            const route = this.$router.resolve({
				name: 'editNotification',
				params: { id },
			});
            window.open(route.href, '_blank');
            this.modalBus.$emit('close');
        },
		async initModal() {
            try {
                this.resultData = await this.restApi().getNotificationById(this.dataModal.notificationId);
            } catch (e) {
                this.modalBus.$emit('close');

                this.$store.commit('activeAlert', {
					message: 'Não foi possível carregar o detalhamento da notificação. Tente novamente.',
					status: 'error',
				});

            }
            this.isLoadingPage = false;
		},
	},
});
